/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { CaseStudyCard } from 'landing-pages/shared/CaseStudyCard/CaseStudyCard';

export const FinancialServicesQuote = () => {
  const { t } = useInt();

  return (
    <CaseStudyCard
      company="American Express"
      title={t('American Express: Streamlining Executive Targeting')}
      summary={t(
        'American Express targets senior executives at the right companies for its premium card offers in the Middle East, built on verified firmographic and contact data rather than purchased lists.',
      )}
      href="/american-express-streamlining-executive-targeting-for-premium-card-offers-in-the-middle-east"
    />
  );
};
